var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.school)?_c('div',[(_vm.rsettings[0].settings.address)?_c('small',[_vm._v(" TEL: "),_c('strong',[_vm._v(_vm._s(_vm.school.phone))]),_c('br'),_vm._v("EMAIL: "),_c('strong',[_vm._v(_vm._s(_vm.school.email))])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }